import React from 'react';
import strings from 'strings';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { UIStatus } from 'UI/constants/status';
import { SvgNotEnoughData } from 'UI/res';

import { PLAIN_STYLES } from './AIGeneratorError.styled';

export const AIGeneratorError = ({ status, error }) => {
  if (status !== UIStatus.Error) return null;
  if (!error?.message) return null;

  return (
    <EmptyPlaceholder
      title={strings.bulkEmails.emailGenerator.notEnoughData.title}
      subtitle={error.message}
      style={PLAIN_STYLES.notEnoughData}
      customEmptyState={<SvgNotEnoughData size={400} />}
    />
  );
};
